import { z } from '@repo/schema'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { GetXeroItemSchema } from '@repo/schema/invoice'
import { GetOrganisationSchema } from '@repo/schema/organisation'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure.ts'

export const createOrganisationsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    list: p.path('organisations').query(({ path, upFetch }) =>
      upFetch(path, {
        schema: getDataWrapperSchema(GetOrganisationSchema.array()),
      }),
    ),

    // GET /organisations/:organisation/xero-connection/items
    xeroItems: p
      .path(z.object({ organisation: z.number() }), p => [
        'organisations',
        p.organisation,
        'xero-connection',
        'items',
      ])
      .query(({ path, upFetch }) =>
        upFetch(path, { schema: getDataWrapperSchema(GetXeroItemSchema.array()) }),
      ),
  }
}
